import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';

import { PendingTeamJoinCheck } from './PendingTeamJoinCheck';

/**
 * The check reads the note when it mounts, so it must not mount on a public
 * page or while sign-in is still resolving.
 */
export function PendingTeamJoinGate() {
  const { isAuthenticated, isLoading } = useIsAuthenticated();

  if (isLoading || !isAuthenticated) return null;
  return <PendingTeamJoinCheck />;
}
